import { Einheit } from 'app/models/core/einheit.model';
import { BnrGpPosModel } from '../bnr.gp.pos.model';
import { PosUnDef } from '../gp';
const posDef: BnrGpPosModel[] = [];

// Gesetzliche Weiterbildungspflicht
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275001,
		group: 'gwp',
		posText: 'Weiterbildung IDD ',
		posDesc: 'Voraussetzung für die Bonifikation ist der Nachweis von 15 Weiterbildungsstunden im Geschäftsjahr',
		planKey: 'idd',
		einheit: Einheit.stck,
	}),
);
// Vertriebsschwerpunkte (außerhalb der Maximierung)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275005,
		group: 'vss',
		posText: 'Qualität in Beratung und Vertrieb',
		posDesc: 'GSL beurteilt die individuelle Zielerreichung anhand konkreter Kriterien',
		planKey: '',
		einheit: Einheit.quali,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275011,
		group: 'vss',
		posText: 'Leben Neustück',
		posDesc: 'Anzahl GV/HV mit Erfüllung der Position VSP Leben Neustück im Geschäftsplan',
		planKey: 'lebnstmaz',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275021,
		group: 'vss',
		posText: 'Leben Einmalbeitrag',
		posDesc: 'Anzahl GV/HV mit mindestens 2.500 Bewertung ohne ZE',
		planKey: 'lebenknpebdigi',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275031,
		group: 'vss',
		posText: 'Kranken HKV',
		posDesc: 'Personen',
		planKey: 'krankenbkVbew',
		einheit: Einheit.bew,
		boniStufen: 2,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275041,
		group: 'vss',
		posText: 'Nettomittelzufluss',
		posDesc: '',
		planKey: 'fondsnettomittelzufluss',
		einheit: Einheit.bew,
	}),
);

// Eingangshürde
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275050,
		group: 'eh',
		posText: 'Produktivität Spezialisten',
		posDesc: 'Anzahl VAS, KME, KVS, UB und Geno-PVS mit Erfüllung der Eingangshürde im Geschäftsplan',
		planKey: '',
		einheit: Einheit.bew,
	}),
);

// Nach Eingangshürde (innerhalb einer Maximierung von 10.000 EUR)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275101,
		group: 'neh',
		posText: 'Leben',
		posDesc: 'Bewertung ohne ZE mit 1,5-facher Wertung PrivateFinance-/PrivateMarketsPolice',
		planKey: 'vaglebenbewdigi',
		einheit: Einheit.bew,
		boniStufen: 2,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275111,
		group: 'neh',
		posText: 'Leben Einmalbeitrag',
		posDesc: 'Bewertung ohne ZE mit 1,5-facher Wertung PrivateFinance-/PrivateMarketsPolice',
		planKey: 'lebenknpebdigi',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275121,
		group: 'neh',
		posText: 'Leben Risiko',
		posDesc: 'Bewertung ohne ZE',
		planKey: '',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275131,
		group: 'neh',
		posText: 'Leben Firmen',
		posDesc: 'Anzahl GV/HV mit mindestens 40.000 (20.000 VG NO) Bewertung ohne ZE',
		planKey: 'lfirmenknp80ris',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275141,
		group: 'neh',
		posText: 'Leben Firmen über FirmenOnline',
		posDesc: 'Bewertung ohne ZE',
		planKey: 'incfuerfach',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275151,
		group: 'neh',
		posText: 'Fonds',
		posDesc: 'Bewertung',
		planKey: 'fondsbew',
		einheit: Einheit.bew,
		boniStufen: 2,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275161,
		group: 'neh',
		posText: 'Betriebliche Krankenversicherung',
		posDesc: 'Bewertung ohne Dynamik',
		planKey: 'krankenneuebefkvgv',
		einheit: Einheit.bew,
		boniStufen: 3,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275171,
		group: 'neh',
		posText: 'Kranken Privat Zusatz',
		posDesc: 'Bewertung ohne Dynamik',
		planKey: 'krankenzusatzbewdigi',
		einheit: Einheit.bew,
		boniStufen: 2,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2275181,
		group: 'neh',
		posText: 'Baufinanzierung Allianz Leben und Bausparen',
		posDesc: 'Bewertung',
		planKey: 'baufinanzierungbew',
		einheit: Einheit.bew,
		boniStufen: 2,
	}),
);

// GeschäftsplanPlus (ohne Eingangshürde und innerhalb einer Maximierung von 4.000 EUR)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 3875021,
		group: 'gpplus',
		posText: 'Wiederanlage',
		posDesc: 'Wiederanlagesumme',
		planKey: 'wiederanlagesumme',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 3875031,
		group: 'gpplus',
		posText: 'Fonds Firmen',
		posDesc: 'Bewertung',
		planKey: '',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 3875041,
		group: 'gpplus',
		posText: 'Kranken Pflege',
		posDesc: 'Anzahl GV/HV mit Erfüllung der Position VSP Kranken Pflege im Geschäftsplan',
		planKey: 'krankenpflege',
		einheit: Einheit.bew,
	}),
);

// Teamausschreibung
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 3875400,
		group: 'gpplus',
		posText: 'Teamausschreibung',
		posDesc: 'Platzierung in den Positionen im GSW der Vertriebsdirektion',
		planKey: '',
		einheit: Einheit.nogoal,
	}),
);
posDef.push(new BnrGpPosModel({ year: 2026, posId: PosUnDef, group: 'gpplus', posText: '', posDesc: 'Kundenzuwachs', planKey: '', einheit: Einheit.nogoal }));
posDef.push(new BnrGpPosModel({ year: 2026, posId: PosUnDef, group: 'gpplus', posText: '', posDesc: 'Cross-Selling', planKey: '', einheit: Einheit.nogoal }));
posDef.push(new BnrGpPosModel({ year: 2026, posId: PosUnDef, group: 'gpplus', posText: '', posDesc: 'Meine Allianz', planKey: '', einheit: Einheit.nogoal }));

export const LpvPositionen = posDef;
